//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent, useStatic, useContext, useRouter, computed } from '@nuxtjs/composition-api'

const pagination = {
  getPostsOfPage($content, page) {
    return $content('blog')
      .only([
        'title',
        'tags',
        'description',
        'featuredImage',
        'slug',
        'published',
      ])
      .sortBy('published', 'desc')
      .skip(10 * (page - 1))
      .limit(10)
      .fetch()
  },

  async getNumberOfPages($content) {
    return Math.ceil((await $content('blog').only([]).fetch()).length / 10)
  },
}

export default defineComponent({
  props: {
    page: {
      type: Number
    }
  },
  setup(props) {
    const { $content } = useContext()

    const currPage = computed(() => props.page)
    const posts = useStatic(page => pagination.getPostsOfPage($content, parseInt(page)), currPage, 'blog-page')
    const pageCount = useStatic(() => pagination.getNumberOfPages($content), undefined, 'blog-page-count')

    const router = useRouter()

    const pageChange = (newPage) => {
      router.push('/blog/' + newPage)
    }

    return { posts, pageCount, pageChange, currPage }
  },
  computed: {
    detailsMaxHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return ''
        default:
          return 'max-height: 300px;'
      }
    },
    imgHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return undefined
        default:
          return 300
      }
    },
  },
  methods: {
    getDescription(item) {
      if (typeof item.description === 'string' && item.description.length > 0) {
        return item.description
      }
      return 'Klicke auf "Mehr Anzeigen", um den Betrag zu vollständig zu lesen.'
    },
  },
})
